<template>
  <div class="row d-flex my-4 pb-md-0 pb-4">
    <div class="col-12">
      <div class="card">
        <div
          class="card-body py-4 px-md-4 rounded-4 transition-shadow
            box-shadow-blue-300 box-shadow-hover-blue-300"
        >
          <div class="row">
            <div class="col-2">
              <v-icon
                icon="chevron-left"
                class="cursor-pointer"
                @click="() => $router.back()"
              />
            </div>
            <div class="col-8">
              <div class="h5 text-center mb-3">
                Votre mot de passe
              </div>
            </div>
            <div class="col-12 col-md-10 mx-auto">
              <form class="form-reset">
                <div
                  v-for="input in form"
                  :key="input.id"
                  class="form-label-group mb-3"
                >
                  <label
                    class="form-label"
                    :for="input.id"
                  >
                    {{ input.label }}
                  </label>
                  <div class="input-group">
                    <input
                      :id="input.id"
                      v-model="input.data"
                      :type="input.isInputPassword ? 'password':'text'"
                      class="form-control border-end-0"
                      required
                    >
                    <div
                      class="cursor-pointer input-group-text border-start-0"
                      @click="input.isInputPassword = !input.isInputPassword"
                    >
                      <v-icon
                        :icon="input.isInputPassword ? 'eye-blue-500': 'eye-hidden-blue-500'"
                        height="19"
                        width="19"
                      />
                    </div>
                  </div>
                </div>
                <transition
                  @enter="tf_slideDown"
                  @leave="tf_slideUp"
                >
                  <div
                    v-if="error !== null"
                    class="col-12 invalid-feedback mb-3"
                  >
                    {{ error }}
                  </div>
                </transition>
                <div class="col-12 mb-3">
                  <div class="row">
                    <div
                      v-for="validator in validators"
                      :key="validator.id"
                      class="col-12 col-md-6 col-lg-4 flex-row d-flex fs-14 text-gray-600 mb-1"
                    >
                      <font-awesome-icon
                        :icon="validator.isValid ? ['fas', 'check']: ['fas', 'circle']"
                        class="d-flex me-1 my-auto"
                        :class="validatorColor(validator.isValid)"
                        style="width:8px; height: 8px"
                      />
                      <div :class="validatorColor(validator.isValid)">
                        {{ validator.message }}
                      </div>
                    </div>
                  </div>
                </div>
                <v-loader
                  :next="updatePassword"
                  :disable-button="(!isPasswordValid)"
                  class="w-100"
                  title="Valider les modifications"
                />
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { routing, transform, ui } from '@/mixins';
import { validatePassword } from '@/utils/validators';

export default {
  name: 'AccountPassword',
  mixins: [routing, transform, ui],
  emits: ['collapsed'],
  data() {
    return {
      form: [
        {
          id: 'oldPassword', data: null, label: 'Votre ancien mot de passe', isInputPassword: true,
        },
        {
          id: 'newPassword', data: null, label: 'Votre nouveau mot de passe', isInputPassword: true,
        },
        {
          id: 'confirmPassword', data: null, label: 'Confirmer mon mot de passe', isInputPassword: true,
        },
      ],
      error: null,
    };
  },
  computed: {
    validators() {
      return validatePassword(this.form[1].data, this.form[2].data);
    },
    isPasswordValid() {
      return !this.validators.some(({ isValid }) => !isValid);
    },
  },
  methods: {
    validatorColor(value) {
      if (value === null) return 'text-gray-500';
      return value ? 'text-green-700' : 'text-red-500';
    },
    async updatePassword() {
      try {
        await this.$store.dispatch('client/updatePassword', {
          oldPassword: this.form[0].data,
          password: this.form[1].data,
          confirmPassword: this.form[2].data,
        });
        this.ui_accountModal({ type: 'password', value: true });
        this.$emit('collapsed', true);
      } catch (err) {
        if (err.response.data.error.reason === 'Old password does not matches current password') {
          this.error = 'Votre ancien mot de passe ne correspond pas à celui renseigné';
        } else {
          this.error = 'Le nouveau mot de passe renseigné ne répond pas à tous les critères de sécurité';
        }
      }
    },
  },
};
</script>
